import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";

import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

import Avatar from "@components/avatar";
import TaskExpectedResult from "@components/onboarding/TaskExpectedResult";
import Button from "@components/tailwindComponents/Button";
import CheckboxSimple from "@components/tailwindComponents/CheckboxSimple";

import EmployeTaskStatusCell from "./EmployeTaskStatusCell";

const BlackTooltip = withStyles(() => ({
  tooltip: {
    "maxWidth": "200px",
    "backgroundColor": "#3F3F51",
    "fontFamily": "Poppins_Medium",
    "fontSize": "12px",
    "padding": "12px 17px",
    "overflow": "hidden",
    "display": "-webkit-box",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": 5
  }
}))(Tooltip);

export default function EmployeTaskItem({
  task,
  onSelect,
  index,
  onManageTaskClicked,
  checked
}) {
  const { t } = useTranslation("beginEnd.protocol");

  const [assignedTo, assignedToOthers] = useMemo(
    () => [
      task.assignedTo?.slice(0, 4) || [],
      task.assignedTo?.slice(4, task.assignedTo?.length) || []
    ],
    [task.assignedTo]
  );
  return (
    <tr className="arh-h-14 arh-border-x-0 arh-border-b arh-border-t-0 arh-border-solid arh-border-borderTable hover:arh-bg-greyColor">
      <td className="arh-w-[15%] arh-text-fontBodyTable arh-font-medium arh-text-darkColor">
        <div className=" arh-flex arh-items-center">
          <CheckboxSimple
            id={task._id}
            name={"task-" + task._id}
            onClick={(e) => onSelect(e, task)}
            checked={checked}
            haveHover={false}
            disabled={task.status === "completed"}
          />
        </div>
      </td>
      <td className="arh-px-[1.125rem] arh-py-1.5 arh-text-fontBodyTable arh-font-medium arh-text-darkColor">
        <div className="arh-flex arh-items-center">
          <BlackTooltip
            placement="top"
            title={task.name}
            id={index}
          >
            <div
              className=" GreenThemeSelect arh-w-[10rem] arh-max-w-fit arh-overflow-hidden arh-text-ellipsis arh-whitespace-nowrap arh-font-poppins arh-text-xs arh-font-medium arh-text-darkGreyColor"
              id={index}
            >
              {task.name}
            </div>
          </BlackTooltip>
        </div>
      </td>
      <td className="arh-px-4 arh-text-fontBodyTable arh-font-medium arh-text-darkColor">
        <TaskExpectedResult type={task.expectedResultType} />
      </td>
      <td className="arh-px-4 arh-text-fontBodyTable arh-font-medium arh-text-darkColor">
        {task.detail ? (
          <BlackTooltip
            placement="top"
            title={
              <p
                className="arh-m-0 arh-w-full"
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 5,
                  fontSize: "12px"
                }}
              >
                {task.detail}
              </p>
            }
            id={index}
          >
            <div
              className="GreenThemeSelect arh-w-full arh-max-w-fit arh-overflow-hidden arh-text-ellipsis arh-whitespace-nowrap arh-font-poppins arh-text-xs arh-font-medium arh-text-darkGreyColor"
              id={index}
            >
              {task.detail || "-"}
            </div>
          </BlackTooltip>
        ) : (
          "-"
        )}
      </td>
      <td className="arh-px-4 arh-text-fontBodyTable arh-font-medium arh-text-darkColor">
        <div className="arh-relative arh-flex arh-w-full arh-items-center arh-justify-center -arh-space-x-2">
          {assignedTo.length
            ? assignedTo.map((assignedEmploye) => (
                <Avatar
                  key={assignedEmploye._id}
                  parentProps={{
                    className:
                      "arh-w-7 arh-h-7 arh-flex arh-border arh-border-solid arh-border-white arh-rounded-full arh-flex-shrink-0"
                  }}
                  src={assignedEmploye.image}
                  title={assignedEmploye.fullname}
                  className="arh-w-full arh-rounded-full arh-object-cover"
                  news={true}
                />
              ))
            : "-"}
          {assignedToOthers?.length ? (
            <BlackTooltip
              placement="top"
              title={
                <div className="arh-flex arh-flex-wrap arh-items-center arh-gap-y-2 -arh-space-x-1.5">
                  {assignedToOthers?.map((assignedEmploye) => (
                    <Avatar
                      key={assignedEmploye._id}
                      parentProps={{
                        className:
                          "arh-w-7 arh-h-7 arh-flex arh-border arh-border-solid arh-border-white arh-rounded-full arh-flex-shrink-0"
                      }}
                      src={assignedEmploye.image}
                      title={assignedEmploye.fullname}
                      className="arh-w-full arh-rounded-full arh-object-cover"
                      news={true}
                    />
                  ))}
                </div>
              }
              id={index}
            >
              <div className="arh-flex arh-h-8 arh-w-8 arh-items-center arh-justify-center arh-overflow-hidden arh-rounded-full arh-border-[1px] arh-border-solid arh-border-white arh-bg-black/80 arh-font-poppins arh-text-xs arh-font-semibold arh-text-white">
                {assignedToOthers?.length < 10
                  ? "+" + assignedToOthers?.length
                  : "10+"}
              </div>
            </BlackTooltip>
          ) : (
            ""
          )}
        </div>
      </td>
      <td className="arh-px-4">
        <EmployeTaskStatusCell task={task} />
      </td>

      {task.status !== "completed" && (
        <td className="arh-px-4 arh-py-1.5 !arh-pr-0 arh-text-right">
          {task.assignedTo.length ? (
            <Button
              variant="green-outlined"
              onClick={onManageTaskClicked}
            >
              {t("Gérer")}
            </Button>
          ) : (
            <Button onClick={onManageTaskClicked}>{t("Assigner")}</Button>
          )}
        </td>
      )}
    </tr>
  );
}
